module.exports = __webpack_public_path__ + "img/stats.76ed74ad.png";